export const OBJECTIVE_RESEARCH_TYPE = {
    student: 'Lycéen',
    job: 'JOB',
    formation: 'FORMATION',
};
